import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faComments, faListCheck, faRotateLeft } from '@fortawesome/free-solid-svg-icons';

/**
 * Something that happened on a task, in the chat between the person who did it
 * and someone else on the task (server: utils/taskUpdateChat.js): a status
 * move, finished work sent back, or new discussion messages.
 *
 * A message from them, on their side of the thread, laid out like the approval
 * card. View opens the task drawer, where the discussion is.
 */

const ids = (v) => String(v?._id || v || '');

const clockTime = (iso) =>
    new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

const statusClass = (status) => `msgr-tchip status-${String(status || '').toLowerCase().replace(/\s+/g, '')}`;

const TaskUpdateCard = ({ id, message, myId, onView }) => {
    const event = message.systemEvent;
    const task = event.task || {};
    const mine = ids(message.sender || event.actor) === String(myId);
    const comment = task.update === 'comment';
    const reopened = task.update === 'reopened';

    const heading = comment
        ? (task.commentCount > 1 ? `${task.commentCount} new messages` : 'New message')
        : reopened ? 'Task sent back' : 'Task update';

    return (
        <div id={id} className={`msgr-msg ${mine ? 'out' : 'in'} first-of-run`}>
            <div className="msgr-bubble msgr-approval msgr-taskupdate">
                <div className="msgr-approval-head">
                    <FontAwesomeIcon icon={comment ? faComments : reopened ? faRotateLeft : faListCheck} />
                    <span><strong>{heading}</strong>{comment ? ' · task discussion' : ''}</span>
                </div>

                <div className="msgr-approval-title">{task.title}</div>

                {comment ? (
                    task.note && <div className="msgr-taskupdate-quote">{task.note}</div>
                ) : (
                    <div className="msgr-taskupdate-move">
                        {task.fromStatus && <span className={statusClass(task.fromStatus)}>{task.fromStatus}</span>}
                        <FontAwesomeIcon icon={faArrowRight} />
                        <span className={statusClass(task.toStatus)}>{task.toStatus}</span>
                    </div>
                )}
                {reopened && task.note && <div className="msgr-taskupdate-quote">{task.note}</div>}

                <div className="msgr-approval-actions">
                    <button type="button" onClick={() => onView?.(ids(task.taskId), false, undefined, { discussion: comment })}>
                        {comment ? 'Open discussion' : 'View task'}
                    </button>
                </div>

                {message.createdAt && <div className="msgr-approval-time">{clockTime(message.createdAt)}</div>}
            </div>
        </div>
    );
};

export default TaskUpdateCard;
